import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class AddingUsers extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Adding Users </h2>

                <br/>
               

                <h6> How To Add A User: </h6>
                
                <p className='text-primary'>1) Click 'users' in the navigation menu along the top.   
                Enter the user's email addresss. </p>
                <br/><br/><br/>
                <div className="text-center">
                <img className='text-center' style={{maxWidth:800, width:"50%", height:"50%"}} src='./images/users.png'  alt=''/> 
              
                   
                </div>

                <br/>
                <p className='text-primary'>2) Locate the green area where is says "Invite User.</p>
                <div className="text-center">
                    <img className='text-center' style={{maxWidth:800, width:"100%",maxHeight:800, height:"100%"}} src='./images/new_user.png' alt=''/> 
                </div>


                 <br/> 
                 <p className='text-primary'>3) Click "Invite User" button at the bottom of the screen. BOUNTE will email that user and 
                invite them to activate the their account and change their password.  There is nothing more the admin has to do at this point.
                If the user doesn't receieve the email, then add the user's email address and click "Invite User" again.  This will warn that
                the user has already been added to the system, however it will email them once again.  NOTE:  In some cases, the invite email
                can be routed to the junk mail. Remind users to check their spam / junk email.  The email should arrive within minutes. </p>


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(AddingUsers);
